import { render, staticRenderFns } from "./ProductListingUpdateScreen.vue?vue&type=template&id=9afc0f44&"
import script from "./ProductListingUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./ProductListingUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports